/* Copyright 2013 - 2024 Waiterio LLC */
import React from 'react'
import Navigation from './NavigationComponent.jsx'
import Footer from './FooterComponent.jsx'

const LayoutComponent = ({ headerStyle, children, locale = 'en' }) => (
  <>
    <Navigation locale={locale} style={headerStyle} />
    {children}
    <Footer locale={locale} />
  </>
)

export default LayoutComponent
